"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultLabel = void 0;
var label_1 = require("../types/record/label");
exports.defaultLabel = (0, label_1.ILabel)();
